<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'playerList' }">{{$t('entities.player.plural')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

      <h2 class="page-title"> {{$t('entities.player.singular')}} history </h2>


    <div v-loading="loading">
      <el-table
        :data="list"
        empty-text="There is no history yet"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="modified"
          label="Updated at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.modified | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Updated by"
          prop="modifiedBy.email"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="Name"
        ></el-table-column>

        <el-table-column
          prop="lastName"
          label="LastName"
        ></el-table-column>

        <el-table-column
          prop="dni"
          label="DNI/NIE/PASAPORTE"
        ></el-table-column>

        <el-table-column
          prop="email"
          label="Email"
        ></el-table-column>

        <el-table-column
          prop="dorsal"
          label="Dorsal"
        ></el-table-column>

        <el-table-column
          prop="phone"
          label="Phone"
        ></el-table-column>

        <el-table-column
          prop="position"
          label="Position"
        >
          <template slot-scope="scope">
            {{ scope.row.position ? scope.row.position.label : '' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="namePublic"
          label="Nombre deportivo"
        ></el-table-column>

        <el-table-column
          prop="created"
          label="Created at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.created | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Created by"
          prop="createdBy.email"
        ></el-table-column>

        <el-table-column
          prop="deleted"
          label="Deleted at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.deleted | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Deleted by"
          prop="deletedBy.email"
        ></el-table-column>
      </el-table>

      <el-button
        v-if="!last"
        @click="fetch()"
        type="infor"
        class="mt-3 w-100"
        icon="el-icon-fa-plus"
      >
        Load more...
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-player-history-full',

  computed: {
    ...mapGetters({
      loading: 'entities/player/historyFull/loading',
      list: 'entities/player/historyFull/list',
      last: 'entities/player/historyFull/last',
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/player/historyFull/setup'
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/player/historyFull/clear',
    );
    next();
  },

  methods: {
    ...mapActions({
      fetch: 'entities/player/historyFull/fetch',
    }),
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/player/player-history/player-history-full/player-history-full.vue?41ba59c0